import React, { useState } from 'react';
import { X, ArrowRight } from 'lucide-react';

export function LoginModal({ t, lang, onClose }) {
  const [slug, setSlug] = useState('');
  const [error, setError] = useState('');

  const goToPanel = () => {
    const s = slug.trim().toLowerCase().replace(/[^a-z0-9-]/g, '');
    if (!s) {
      setError(lang === 'it' ? 'Inserisci lo slug della tua struttura.' : 'Please enter your property slug.');
      return;
    }
    window.location.href = `/panel/login?tenant=${s}`;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4"
      style={{ background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(8px)' }}>
      <div className="w-full max-w-sm rounded-sm"
        style={{ background: 'var(--lux-surface-1)', border: '1px solid var(--lux-border-1)' }}>
        <div className="flex items-center justify-between px-6 py-4"
          style={{ borderBottom: '1px solid var(--lux-border-1)' }}>
          <h3 className="font-serif text-lg font-light" style={{ color: 'var(--lux-text)' }}>{t.login_title}</h3>
          <button onClick={onClose} style={{ color: 'var(--lux-text-muted)' }}><X size={18} /></button>
        </div>
        <div className="p-6 space-y-4">
          <p className="text-xs" style={{ color: 'var(--lux-text-muted)' }}>{t.login_sub}</p>
          <div>
            <label className="block text-[10px] uppercase tracking-widest mb-1.5"
              style={{ color: 'var(--lux-text-muted-2)' }}>{t.login_slug_label}</label>
            <input
              value={slug} onChange={e => setSlug(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && goToPanel()}
              placeholder={t.login_slug_placeholder} autoFocus
              className="w-full rounded-sm px-4 py-3 text-sm"
              style={{ background: 'var(--lux-surface-3)', border: '1px solid var(--lux-border-2)', color: 'var(--lux-text)' }}
              data-testid="login-modal-slug-input"
            />
            {error && <p className="text-red-400 text-xs mt-1">{error}</p>}
          </div>
          <button onClick={goToPanel}
            className="w-full py-3 text-sm font-semibold tracking-wide uppercase flex items-center justify-center gap-2"
            style={{ background: 'var(--lux-gold)', color: '#000' }}
            data-testid="login-modal-go-btn">
            {t.login_go} <ArrowRight size={14} />
          </button>
          <p className="text-[11px] text-center" style={{ color: 'var(--lux-text-muted-3)' }}>
            {t.login_no_account}{' '}
            <button
              onClick={() => {
                onClose();
                setTimeout(() => document.getElementById('demo')?.scrollIntoView({ behavior: 'smooth' }), 100);
              }}
              className="underline" style={{ color: 'var(--lux-gold)' }}>
              {lang === 'it' ? 'Prova la demo gratuita' : 'Try the free demo'}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
